/**
 * ZINNIA COLLECTION JS
 * 1. Color circle hover: preview related product image
 * 2. View More: AJAX load 20 products per click
 */
(function () {
  'use strict';

  /* ============================================================
     1. COLOR CIRCLE HOVER PREVIEW
     - mouseenter on .zinnia-color-circle → change primary image src
     - mouseleave → restore original image
     - Works on desktop (pointer: fine) only
     - Also works on newly AJAX-loaded cards
     ============================================================ */
  function initColorCircleHover(root) {
    root = root || document;

    // Use event delegation on document for AJAX-loaded cards
    if (root === document && window._zinniaColorHoverInit) return;
    if (root === document) window._zinniaColorHoverInit = true;

    document.addEventListener('mouseenter', function (e) {
      if (!e.target || typeof e.target.closest !== 'function') return;
      var circle = e.target.closest('.zinnia-color-circle');
      if (!circle) return;

      // Only on desktop (pointer: fine)
      if (!window.matchMedia('(pointer: fine)').matches) return;

      var previewSrc = circle.getAttribute('data-preview-src');
      if (!previewSrc) return;

      var card = circle.closest('product-card');
      if (!card) return;

      var primaryImg = card.querySelector('.zinnia-primary-img');
      if (!primaryImg) return;

      // Save original src if not already saved
      if (!primaryImg.dataset.originalSrc) {
        primaryImg.dataset.originalSrc = primaryImg.src;
      }

      // Change src to preview
      primaryImg.src = previewSrc;
      primaryImg.style.opacity = '0';
      primaryImg.onload = function () {
        primaryImg.style.opacity = '1';
      };
    }, true);

    document.addEventListener('mouseleave', function (e) {
      if (!e.target || typeof e.target.closest !== 'function') return;
      var circle = e.target.closest('.zinnia-color-circle');
      if (!circle) return;

      if (!window.matchMedia('(pointer: fine)').matches) return;

      var card = circle.closest('product-card');
      if (!card) return;

      var primaryImg = card.querySelector('.zinnia-primary-img');
      if (!primaryImg) return;

      // Restore original src
      var originalSrc = primaryImg.dataset.originalSrc;
      if (originalSrc && primaryImg.src !== originalSrc) {
        primaryImg.src = originalSrc;
      }
    }, true);
  }

  /* ============================================================
     2. VIEW MORE — AJAX LOAD
     - paginate by 20 in Liquid
     - currentPage starts at 2
     - Each click fetches next page and appends product cards
     - Preserves all URL params (filters, sort)
     - Works with banner blocks (they stay in place)
     ============================================================ */
  function initViewMore() {
    var btn = document.getElementById('zinnia-view-more-btn');
    if (!btn) return;

    var grid = document.getElementById(btn.getAttribute('data-grid-id'));
    var totalPages = parseInt(btn.getAttribute('data-total-pages'), 10);
    var currentPage = 2; // First page already loaded
    var isLoading = false;

    var loadingDots = document.getElementById('zinnia-loading-dots');
    var allLoadedMsg = document.getElementById('zinnia-all-loaded-msg');

    // Hide button if only 1 page
    if (totalPages <= 1) {
      hideButton();
      return;
    }

    btn.addEventListener('click', function () {
      if (isLoading) return;
      if (currentPage > totalPages) {
        hideButton();
        return;
      }

      isLoading = true;
      btn.disabled = true;
      if (loadingDots) loadingDots.classList.add('is-active');
      btn.querySelector('.zinnia-btn-text').style.display = 'none';

      // Build URL: preserve all current params, set page=currentPage
      var url = buildPageUrl(currentPage);

      fetch(url, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Network error: ' + res.status);
          return res.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');

          // Find the product-list in the fetched page
          var fetchedGrid = doc.querySelector('product-list');
          if (!fetchedGrid) {
            // Try alternative selector
            fetchedGrid = doc.querySelector('.product-list');
          }

          if (!fetchedGrid) {
            console.warn('[Zinnia] Could not find product-list in fetched page');
            hideButton();
            return;
          }

          // Extract only product-card elements (not banners)
          var newCards = fetchedGrid.querySelectorAll('product-card');

          if (newCards.length === 0) {
            hideButton();
            return;
          }

          // Append new cards to grid
          newCards.forEach(function (card) {
            grid.appendChild(card.cloneNode(true));
          });

          currentPage++;

          if (currentPage > totalPages) {
            hideButton();
            showAllLoaded();
          }
        })
        .catch(function (err) {
          console.error('[Zinnia View More] Error:', err);
        })
        .finally(function () {
          isLoading = false;
          btn.disabled = false;
          if (loadingDots) loadingDots.classList.remove('is-active');
          btn.querySelector('.zinnia-btn-text').style.display = '';
        });
    });

    function buildPageUrl(page) {
      var url = new URL(window.location.href);
      url.searchParams.set('page', page);
      return url.toString();
    }

    function hideButton() {
      var container = document.getElementById('zinnia-view-more-container');
      if (btn) btn.style.display = 'none';
    }

    function showAllLoaded() {
      if (allLoadedMsg) allLoadedMsg.style.display = 'block';
    }
  }

  /* ============================================================
     INIT
     ============================================================ */
  function init() {
    initColorCircleHover(document);
    initViewMore();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
(function () {
  const slider = document.querySelector('[data-zbb-single-image-slider]');
  if (!slider) return;

  const slides = Array.from(slider.querySelectorAll('.zbb-single-image-slider__slide'));
  const prev = slider.querySelector('.zbb-single-image-slider__arrow--prev');
  const next = slider.querySelector('.zbb-single-image-slider__arrow--next');

  if (!slides.length) {
    if (prev) prev.style.display = 'none';
    if (next) next.style.display = 'none';
    return;
  }

  let current = 0;

  function showSlide(index) {
    slides[current].classList.remove('is-active');
    current = (index + slides.length) % slides.length;
    slides[current].classList.add('is-active');
  }

  if (slides.length === 1) {
    if (prev) prev.style.display = 'none';
    if (next) next.style.display = 'none';
    slides[0].classList.add('is-active');
    return;
  }

  if (prev) {
    prev.addEventListener('click', function () {
      showSlide(current - 1);
    });
  }

  if (next) {
    next.addEventListener('click', function () {
      showSlide(current + 1);
    });
  }

  slides.forEach(function (slide, index) {
    if (index === 0) {
      slide.classList.add('is-active');
    } else {
      slide.classList.remove('is-active');
    }
  });
})();
/* =====================================================
   FIX — ZINNIA Single Image Slider Navigation
   ===================================================== */
document.addEventListener('click', function (event) {
  if (!event.target || typeof event.target.closest !== 'function') return;
  const nextButton = event.target.closest('.zbb-single-image-slider__arrow--next');
  const prevButton = event.target.closest('.zbb-single-image-slider__arrow--prev');

  if (!nextButton && !prevButton) return;

  event.preventDefault();
  event.stopPropagation();

  const slider = event.target.closest('.zbb-single-image-slider');
  if (!slider) return;

  const slides = Array.from(slider.querySelectorAll('.zbb-single-image-slider__slide'));
  if (!slides.length) return;

  let currentIndex = slides.findIndex(function (slide) {
    return slide.classList.contains('is-active');
  });

  if (currentIndex < 0) currentIndex = 0;

  slides[currentIndex].classList.remove('is-active');

  let nextIndex;

  if (nextButton) {
    nextIndex = currentIndex + 1;
  } else {
    nextIndex = currentIndex - 1;
  }

  if (nextIndex >= slides.length) nextIndex = 0;
  if (nextIndex < 0) nextIndex = slides.length - 1;

  slides[nextIndex].classList.add('is-active');
});
